import { createInspectionCode } from 'helpers/generators';
import {
  normalizeIssueNumberForSearch,
  resolveIssueProcessCode,
} from 'shared/domain/issue/issueNumber';

export type InspectionCodeSource = {
  _id: string;
  createdAt: string;
};

export type InspectionNumberSearchFields = {
  inspectionNumberSearch: string;
  inspectionNumberSearchNormalized: string;
};

export function buildInspectionNumberSearchString(
  inspection: InspectionCodeSource,
  templateProcessId: string
): string {
  return createInspectionCode(
    inspection.createdAt,
    inspection._id,
    resolveIssueProcessCode(templateProcessId)
  );
}

export function toInspectionNumberSearchFields(
  inspection: InspectionCodeSource,
  templateProcessId: string
): InspectionNumberSearchFields {
  const inspectionNumberSearch = buildInspectionNumberSearchString(
    inspection,
    templateProcessId
  );
  return {
    inspectionNumberSearch,
    inspectionNumberSearchNormalized:
      normalizeIssueNumberForSearch(inspectionNumberSearch),
  };
}
